module.exports = __webpack_public_path__ + "img/logo.b64dab45.png";